import type { Compare } from '@festina-life/core'

import type { SubTemplateFieldValue } from '../../types/templateModel'
import { DiffPopoverLayout } from './DiffPopoverLayout'
import { SubTemplateFieldValueDiffContents } from './SubTemplateFieldValueDiffContents'
import { TemplateFieldDiffHeader } from './TemplateFieldDiffHeader'

type Props = Compare<SubTemplateFieldValue> & {
  isShowingFieldName?: boolean
}

/**
 * Diff component used to show changes on a subtemplate variant
 */
export const SubTemplatedFieldValueDiff = ({
  isShowingFieldName,
  ...props
}: Props) => (
  <DiffPopoverLayout>
    <div className="mb-8 grid grid-cols-2 gap-x-24">
      <TemplateFieldDiffHeader
        fieldName={
          isShowingFieldName
            ? props.current?.subTemplatedField?.name
            : undefined
        }
        current={props.current?.subTemplatedField?.origin}
        compare={props.compare?.subTemplatedField?.origin}
      />
    </div>
    <div className="flex flex-col gap-y-4">
      <SubTemplateFieldValueDiffContents {...props} />
    </div>
  </DiffPopoverLayout>
)
